var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQwikIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 16,
    viewBox: "0 0 63 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.045 0c3.784 0 6.708 2.119 6.708 5.978 0 2.856-1.185 5.183-3.173 6.564l1.262 1.286-2.35 2.157-2.027-2.194a9.106 9.106 0 0 1-1.624.15c-2.929 0-5.434-1.39-6.294-3.912l-5.592-1.47h5.294V8.55h1.874L7.29 6.904c.025-.212.056-.421.095-.626L0 4.257h10.199l-1.4-1.282C10.181 1.12 12.385 0 15.045 0zm-.115 3.027C12.541 3.007 11.3 5.354 11.3 7.87c0 1.267.478 2.307 1.433 2.818l2.275-1.854 1.261 1.306c.936-.89 1.414-2.384 1.414-4.03 0-1.664-.84-3.064-2.752-3.083z",
    fill: "url(#rzrd8rfqsa)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.335 8.778 30.622.189h3.307l.764 8.664L37.903.19h3.613L36.07 13.715h-3.841l-.784-8.248-3.364 8.248h-3.956L22.977.189h3.976l.382 8.589z",
    fill: "url(#boph3itcfb)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.867 13.715H40.91L43.07.189h3.956l-2.16 13.526z",
    fill: "url(#by286mzqkc)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.809 5.562 57.854.189h4.205l-6.192 6.47 4.07 7.056h-4.223l-3.268-5.883-.937 5.883h-3.937L49.732.189h3.937l-.86 5.373z",
    fill: "url(#g2j35966ld)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rzrd8rfqsa",
    x1: 62.059,
    y1: 7.992,
    x2: 0,
    y2: 7.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE2C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boph3itcfb",
    x1: 62.059,
    y1: 7.992,
    x2: 0,
    y2: 7.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE2C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "by286mzqkc",
    x1: 62.059,
    y1: 7.992,
    x2: 0,
    y2: 7.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE2C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2j35966ld",
    x1: 62.059,
    y1: 7.992,
    x2: 0,
    y2: 7.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE2C00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQwikIcon);
export default __webpack_public_path__ + "static/media/qwik-icon.e58e67068a90f3230dd579a67bebde94.svg";
export { ForwardRef as ReactComponent };